import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import Card from '../Card';
import ProjectCardProps from './ProjectCardProps';
import useHackathon from '@/data/hook/hackathon/useHackathon';
import ProjectPermissions from '@/utils/permissions/ProjectPermission';
import useAuth from '@/data/hook/useAuth';

export default function CreateMeProjectCard({
  project,
  onMutate,
  className,
}: ProjectCardProps) {
  const { hackathon, isLoading } = useHackathon();

  const { user } = useAuth();

  const permissions = new ProjectPermissions({
    hackathon,
    user,
    model: project,
    isLoadingHackathon: isLoading,
  });
  return (
    <Card key={project.id} project={project} className={className?.base}>
      <ConditionalRenderer condition={permissions.canInteract()}>
        <Card.Interactions project={project} onMutate={onMutate} />
      </ConditionalRenderer>
      <Card.Banner url={project.image} />
      <Card.FlexGroup>
        <Card.Title title={project.title} className="grow" />
        <Card.OwnerActions project={project} />
      </Card.FlexGroup>
      <Card.Tags tool={project.tool} flags={project.flags} />
      <Card.FlexGroup>
        <Card.PublushDate publishAt={project.createdAt} />
        <Card.Owners owners={project.users} />
      </Card.FlexGroup>
    </Card>
  );
}
